<template>
  <div
    class="flex items-center"
    :class="{
      'justify-end': isHomepage,
      'justify-between': !isHomepage,
    }"
  >
    <div
      v-if="!isHomepage"
      class="md:flex flex-grow overflow-hidden mr-2 items-center"
    >
      <div class="hidden lg:inline-block">
        <div class="uppercase text-xxs ml-4 text-gray-500 mb-0.5">
          {{ $t("domain") }}
        </div>
        <SelectCustom
          :value="domainId"
          @input="routeDomain"
          :hasTranslation="true"
          :options="domainsOptions"
          class="w-full md:w-60"
          select-class="border-tertiary hover:bg-tertiary hover:text-white focus:ring-0"
        />
      </div>
      <div
        v-if="$route.name === 'risk'"
        class="hidden lg:inline-block ml-2 w-24 md:w-60 transform transition-transform"
        :class="{ 'translate-y-16': !showIndicatorSelect }"
      >
        <div class="uppercase text-xxs ml-4 text-gray-500 mb-0.5">
          {{ $t("indicator")}}
        </div>
        <SelectCustom
          :value="indicatorId"
          @input="routeIndicator"
          :hasTranslation="true"
          :options="indicators"
          select-class="focus:ring-0"
        />
      </div>
    </div>
    <!-- space-x-2 -->
    <RouterSwitch
      :options="pages"
      :active="active"
      class="flex-shrink-0 text-sm md:text-lg top-menu -mb-0.5 md:-mb-6 overflow-x-scroll hide-scrollbar uppercase leading-tight tracking-tight"
      item-class="text-secondary border-b-2 md:border-b-4 border-transparent hover:text-gray-700 hover:border-gray-300 focus:border-gray-300 focus:text-gray-700 transition duration-500 font-medium py-2 px-2 sm:px-2 bg-transparent focus:outline-none "
      inner-container-class="space-x-1 sm:space-x-2 whitespace-nowrap"
      item-active-class="text-secondary font-semibold"
      slider-class="absolute inset-y-0 w-full border-b-2 md:border-b-4 border-secondary ease-out duration-500 z-10"
      rounded-style="rounded-none"
    />
  </div>
</template>

<script>
import RouterSwitch from "@/components/RouterSwitch";
import SelectCustom from "@/components/SelectCustom";
import { regionsToCountries } from "../utils/helpers";
import getTranslations from "@/utils/getTranslations"; 
// import countries from "@/assets/data/countries";
const countries = regionsToCountries();

export default {
  components: {
    RouterSwitch,
    SelectCustom,
  },
  data() {
    return {
      showIndicatorSelect: false,
    };
  },
  computed: {
    dataset() {
      return this.$route.params.dataset || "girls";
    },
    isHomepage() {
      return !this.$route.params.domainId;
    },
    selectedDomains() {
      const { domains } = getTranslations(this.$i18n);
      return domains;
    },
    domainId() {
      return (
        this.$route.params.domainId ||
        this.selectedDomains.find((e) => !e[`disabled_${this.dataset}`]).id
      );
    },
    indicators() {
      const indicators =
        this.selectedDomains.find((e) => e.id === this.domainId)?.indicators ||
        [];
      return indicators.map((e) => ({
        ...e,
        name: this.$t(e.short) || this.$t(e.name),
        disabled: e[`disabled_${this.dataset}`],
      }));
    },
    indicatorId() {
      // find the first indicator that is not disabled of this domain
      const indicatorId = this.domain?.indicators.find(
        (e) => !e[`disabled_${this.dataset}`]
      )?.id;
      // the one on the route, or if there's none, the first one on the list of indicators for this domain
      return this.$route.params.indicatorId || indicatorId;
    },
    iso() {
      // the order of preference for the country iso is:
      // 1 - URL param
      // 2 - localStorage value
      // 3 - Random
      return this.$route.params.iso || localStorage.getItem("iso") || "CMR";
    },
    regionId() {
      // // first region on the list
      // const regionId = regions[0].id;
      // // the one on the route, or if there's none, the first one on the list of regions
      // return this.$route.params.regionId || regionId;
      return (
        this.$route.params.regionId ||
        countries[this.iso] ||
        "sub-saharan-africa"
      );
    },
    pages() {
      const params = { domainId: this.domainId };
      // check if this domain is disabled for the Risks page
      const isRisksDisabled = this.selectedDomains.find((e) => e.id === this.domainId)[
        `disabled_${this.dataset}`
      ];
      if (isRisksDisabled) {
        // select the first domain in the list
        params.domainId = this.selectedDomains.find(
          (e) => !e[`disabled_${this.dataset}`]
        ).id;
      }
      // find the first indicator NOT disabled in this domain
      // const indicatorId = domains
      //   .find((e) => e.id === params.domainId)
      //   ?.indicators.find((e) => !e[`disabled_${this.dataset}`])?.id;

      return [
        {
          name: "Home",
          icon: "home",
          exact: true,
          to: {
            name: "home",
          },
        },

        {
          name: "navBar.girls.title",
          exact: true,
          to: {
            name: "risk",
            // params: { ...params, indicatorId, iso: this.iso },
            params: { dataset: "girls" },
            // query: { dataset: "girls" },
          },
        },
        {
          name: "navBar.boys.title",
          exact: true,
          to: {
            name: "risk",
            // params: { ...params, indicatorId, iso: this.iso },
            params: { dataset: "boys" },
          },
        },

        {
          name: "navBar.policy",
          exact: true,
          to: {
            name: "policy",
            params: { ...params, regionId: this.regionId },
          },
        },
      ];
    },
    active() {
      if (this.$route.name === "home") return "Home";
      if (this.$route.name === "risk" && this.dataset === "girls")
        return "navBar.girls.title";
      if (this.$route.name === "risk" && this.dataset === "boys")
        return "navBar.boys.title";
      return "navBar.policy";
    },
    domainsOptions() {
      return [
        { name: `-- ${this.$t("select-domain").toUpperCase()} --`, id: "" },
        ...this.selectedDomains.map((e) => ({
          ...e,
          disabled: e[`disabled_${this.dataset}`],
        })),
      ];
    },
  },
  methods: {
    routeDomain(domainId) {
      // const domainId = event.target.value;
      // find the first indicator of this domain
      const indicatorId = this.selectedDomains.find((e) => e.id === domainId)?.indicators[0]
        ?.id;

      // if back to homepage, remove the ISO from the URL
      if (!domainId) this.route({ domainId, indicatorId, iso: "" });
      // reset the indicatorId when changing the domain
      else this.route({ domainId, indicatorId, iso: this.iso });
    },
    routeIndicator(indicatorId) {
      this.route({ indicatorId });
    },
    route(params) {
      const query = { ...this.$route.params, ...params };

      for (const key in query) {
        if (Object.hasOwnProperty.call(query, key)) {
          if (!query[key]) delete query[key];
        }
      }

      this.$router.push({
        name: this.$route.name,
        params: query,
        // query: this.$route.query,
      });
    },
  },
  mounted() {
    let lastKnownScrollPosition = 0;
    let ticking = false;

    const toggleShowIndicator = (scrollPos) => {
      if (scrollPos > 264) this.showIndicatorSelect = true;
      else this.showIndicatorSelect = false;
    };

    document.addEventListener("scroll", () => {
      lastKnownScrollPosition = window.scrollY;

      if (!ticking) {
        window.requestAnimationFrame(() => {
          toggleShowIndicator(lastKnownScrollPosition);
          ticking = false;
        });

        ticking = true;
      }
    });
  },
};
</script>
